import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { useRef } from 'react'

// Components
import Icon from '@/assets/icons'
import Button from '@/components/common/livemallclub/Button'
import Popup from '@/components/common/Popup'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const VipOnlyPopup = ({ isOpen, handleClose }: { isOpen: boolean; handleClose: () => void }) => {
  const { t } = useTranslation()
  const popupRef = useRef<HTMLDivElement>(null)

  return (
    <Popup
      ref={popupRef}
      title={t('Common_VIP_Only')}
      canClose={false}
      hasCancel={false}
      hasConfirm={false}
      icon={
        <div className={cx('vip-only-popup__icon')}>
          <Icon.Diamond />
        </div>
      }
      isOpen={isOpen}
    >
      <div className={cx('vip-only-popup')}>
        <p className={cx('vip-only-popup__description')}>{t('VIP_Only_Popup_Description')}</p>
        <Button onClick={handleClose} theme='pink'>
          {t('VIP_Only_Popup_Button')}
        </Button>
      </div>
    </Popup>
  )
}

export default VipOnlyPopup
